import React, { useMemo, useEffect, useReducer, useState } from "react";
import { Link } from "react-router-dom";
import useFetchProcessed from "../../Hooks/qlp_ddpcr/useFetchProcessed";
import * as fileConstants from "../../constants/fileConstants";
import { setHeaders } from "../../../utils/basic";
import Toaster from "../../common/Toaster";
import * as config from "../../../app.config";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import axios from 'axios';
import {
    FormControl,
    MenuItem,
    Select
} from '@material-ui/core';
import produce from "immer";
import DropdownRenderer from "../../common/Renderers/DropDownRenderer";
import useFetchSerialNumbers from "../../Hooks/Mfg/useFetchSerialNumbers";
import Spinner from "../../common/Spinner";

const initialState = {
    selectedOptions: {},
    sendDisabled: true,
    gridRows: [],
    showNotification: false,
};

// add reducer in this file itself, to avoid defining the actions in a separate file since its a local reducer
// you can also do const reducer = produce((draft,action) => {
// switch (action.type) {
//     case "SET_SELECTED_OPTIONS":
//         draft.selectedOptions[action.id] = action.value;
//         break;
//})
function reducer(state, action) {
    switch (action.type) {
        case 'SET_GRID_ROWS':
            return produce(state, (draftState) => {
                draftState.gridRows = action.payload;
            });
        case 'SET_SELECTED_OPTIONS':
            return produce(state, (draftState) => {
                draftState.selectedOptions = action.payload;
            });
        case 'SET_SEND_DISABLED':
            return produce(state, (draftState) => {
                draftState.sendDisabled = action.payload;
            });

        case "RESET_GRID_ROWS":
            return produce(state, (draftState) => {
                draftState.gridRows.forEach((row) => {
                    row.plateOptions = "";
                });
            });
        case 'SET_SHOW_NOTIFICATION':
            return produce(state, (draftState) => {
                draftState.showNotification = action.payload;
            });
        default:
            return state;
    }
}



const ddPcrMFG = () => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const { selectedOptions, sendDisabled, gridRows, showNotification } = state;
    // Filter your rows based on the filter state
    const [filter, setFilter] = useState('');
    const verificationPlateOptions = ["Flu_Ver", "FAM/VIC", "FAM/HEX", "Probes", "Eva"];
    const fileType = fileConstants.fileTypes.ddpcr;

    const ddpcrQuery = useFetchProcessed(fileType);

    const ddpcrData = ddpcrQuery?.isSuccess ? ddpcrQuery.data.data : null;
    const serialNumbers = useFetchSerialNumbers();

    const dataForTable = (ddpcrData) => ddpcrData?.map(item => {
        const properties = {
            "id": item.run_uuid,
            "fileName": item.data_filename ? item.data_filename.split('\\\\').pop() : "No Filename",
            "plate_uuid": item.plate_uuid,
            "unit": item.serialnumber,
            "plateOptions": '',
        };
        return properties;
    });

    const data = useMemo(() => {
        return dataForTable(ddpcrData);
    }, [ddpcrData]);

    // reason we need to set the gridRows to the data from the query is because one cannot update the data returned from the hook directly in the 
    // Datagrid when the user edits a row.
    useEffect(() => {
        dispatch({ type: 'SET_GRID_ROWS', payload: data });
    }, [data]);

    // Filter your rows based on the filter state
    const filteredRows = filter && filter !== 'All' ? gridRows.filter(row => row.unit === filter) : gridRows;


    const checkSendButtonDisabled = () => {
        const selectedRows = gridRows?.filter((row) => row.plateOptions !== '');
        const disable = selectedRows?.length < 4;
        dispatch({ type: 'SET_SEND_DISABLED', payload: disable });// here disable evaluates to boolean from line 98
    };
    const handleCellEditCommit = (params) => {
        const field = params.field;
        const newValue = params.value;
        const id = params.id;
        if (field && id) {
            // Calculate updatedRows first
            const updatedRows = gridRows.map((row) => {
                if (row.id === id) {
                    if (field === 'plateOptions') {
                        return { ...row, plateOptions: newValue };
                    }
                    return { ...row, [field]: newValue };
                }
                return row;
            });

            dispatch({
                type: "SET_GRID_ROWS",
                payload: updatedRows
            });
            // Calculate updatedSelectedOptions
            const updatedSelectedOptions = { ...state.selectedOptions, [id]: newValue };
            dispatch({ type: "SET_SELECTED_OPTIONS", id, payload: updatedSelectedOptions });
        }
        else {
            console.log("Field or id is not defined");
        }
        checkSendButtonDisabled();
    };


    const getDisabledOptions = (currentRowId) => {
        const disabledOptions = [];
        gridRows?.forEach((row) => {
            if (row.id !== currentRowId && selectedOptions[row.id]) {
                disabledOptions.push(selectedOptions[row.id]);
            }
        });
        return disabledOptions;
    };

    const handleSendClick = () => {
        const selectedRows = gridRows.filter((row) => row.plateOptions !== '');
        const payload = JSON.stringify(selectedRows.map(({ id, ...rest }) => rest));
        // evaluate if you need a useMutation, since all you are doing is sending data ( no look ups) hook later after testing it works
        const headerConfig = setHeaders();
        axios.post(`${config.ENDPOINTS["datalake"]}/ddpcr/mfg_stats`, payload, {
            headers: headerConfig
        })
            .then(response => {
                dispatch({ type: 'SET_SHOW_NOTIFICATION', payload: true });
                dispatch({ type: 'RESET_GRID_ROWS' });
                // Enable the send button
                dispatch({ type: "SET_SEND_DISABLED", payload: true });
                dispatch({ type: 'SET_SELECTED_OPTIONS', payload: {} });
                // Set showNotification back to false after a 3-second delay
                setTimeout(() => {
                    dispatch({ type: 'SET_SHOW_NOTIFICATION', payload: false });
                }, 3000);

                //dispatch({ type: 'SET_SHOW_NOTIFICATION', payload: false });
            })
            .catch(error => {
                console.error(error);
            });
    };



    const getPlateOptionItems = (currentRowId) => {
        const disabledOptions = getDisabledOptions(currentRowId);

        return verificationPlateOptions.map((option) => (
            <MenuItem
                key={option}
                value={option}
                disabled={disabledOptions.includes(option)}
            >
                {option}
            </MenuItem>
        ));
    };
    const handleResetClick = () => {
        dispatch({ type: "RESET_GRID_ROWS" });
        dispatch({ type: "SET_SEND_DISABLED", payload: true });
        dispatch({ type: 'SET_SHOW_NOTIFICATION', payload: false });
        dispatch({ type: 'SET_SELECTED_OPTIONS', payload: {} });
    };


    const cols = [
        {
            field: 'fileName',
            headerName: 'File Name',
            description: 'Name of the File',
            renderCell: (params) => (
                <Link to={`/ddpcr/detail/${params.row.plate_uuid}`}>{params.value}</Link>
            ),
            width: 800
        },
        {
            field: 'plateOptions',
            headerName: 'Plate Options',
            width: 400,
            editable: true,
            renderCell: (params) => (
                <FormControl>
                    <Select
                        value={params.value || 'choose'}
                        onChange={(event) => {
                            handleCellEditCommit({
                                ...params,
                                field: 'plateOptions',
                                id: params.row.id,
                                value: event.target.value,
                                api: params.api
                            });

                        }}
                    >
                        <MenuItem value="choose">
                            --Select--
                        </MenuItem>
                        {getPlateOptionItems(params.row.id)}
                    </Select>
                </FormControl>
            ),
        },
        {
            field: 'unit',
            headerName: 'Serial Number',
            description: 'unit',
            width: 300
        }

    ];
    return (
        <>
            <h5 className="text-custom-green font-bold text-center pb-10">SEND REPORT</h5>
            <div className="oneToolContainer flex flex-col h-[80dvh]">
                <div className="flex gap-x-2 justify-end items-end mt-2">
                    <button className={`text-white px-4 py-2 rounded-lg flex shadow-md 
                        ${sendDisabled ? 'bg-gray-400 cursor-not-allowed' : "bg-green-700"}`}
                        type="submit" onClick={handleSendClick}>SEND</button>

                    <button className={`text-white px-4 py-2 rounded-lg flex shadow-md 
                        bg-green-700`}
                        onClick={handleResetClick}>RESET</button>
                </div>
                {ddpcrData?.length > 0 && serialNumbers?.data ? (
                    <>
                        {showNotification && <Toaster
                            text={"Success! Report Created"}
                            key={crypto.randomUUID()}
                            autoHideDuration={3000}
                            type="success"
                        />}
                        <label htmlFor="dropdownValue" className="dropdown-label">Serial Numbers</label>
                        <DropdownRenderer
                            options={['All', ...(serialNumbers?.data ?? [])]}
                            onSelect={setFilter}
                            handleClose={() => { }}
                        />
                        <DataGrid rows={filteredRows ?? []}
                            columns={cols}
                            onCellEditCommit={handleCellEditCommit}
                            components={{
                                Toolbar: GridToolbar,
                            }} />
                    </>) : ddpcrQuery?.isFetching ?
                    <Spinner text="Fetching Data... Please wait" /> :
                    ddpcrQuery?.isLoadingError ? <p> Sorry could not load files...loading error </p> : "No processed files yet.."
                }
            </div>
        </>
    );

}

export default ddPcrMFG;
